import React from "react";
import { Clock, UtensilsCrossed } from "lucide-react";

export default function MenuSection({ t }) {
  return (
    <section
      id="menu"
      data-testid="menu-section"
      className="relative bg-[#EAE4D9] py-24 sm:py-32"
    >
      <div className="mx-auto max-w-7xl px-6 sm:px-10 lg:px-16">
        <div className="max-w-3xl">
          <p
            data-testid="menu-eyebrow"
            className="mb-6 font-body text-xs uppercase tracking-[0.4em] text-[#5C3A21]"
          >
            — {t.menu.eyebrow}
          </p>
          <h2
            data-testid="menu-title"
            className="font-serif-display text-5xl leading-[1.05] text-[#1A1A1A] sm:text-6xl"
          >
            {t.menu.title}
          </h2>
          <p
            data-testid="menu-intro"
            className="mt-8 font-body text-base leading-relaxed text-[#4A4A4A] sm:text-lg"
          >
            {t.menu.intro}
          </p>
        </div>

        <div className="mt-16 grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-12">
          {/* Menu del día card */}
          <div className="lg:col-span-5">
            <div
              data-testid="menu-of-day"
              className="relative h-full bg-[#1A1A1A] p-10 text-[#F5F2EB] sm:p-12"
            >
              <div className="flex items-center gap-3">
                <Clock className="h-4 w-4" strokeWidth={1.5} />
                <span className="font-body text-xs uppercase tracking-[0.35em] text-[#EAE4D9]">
                  {t.menu.menuOfDay.schedule}
                </span>
              </div>
              <h3 className="mt-8 font-serif-display text-4xl italic text-[#F5F2EB] sm:text-5xl">
                {t.menu.menuOfDay.title}
              </h3>
              <div className="mt-10 divider-line bg-[#F5F2EB]/30" />
              <p className="mt-8 font-body text-sm leading-relaxed text-[#EAE4D9]/90">
                {t.menu.menuOfDay.line1}
              </p>
              <div className="mt-8 flex items-baseline gap-4">
                <span className="font-serif-display text-7xl text-[#F5F2EB] sm:text-8xl">
                  {t.menu.menuOfDay.price}
                </span>
                <span className="font-body text-xs uppercase tracking-[0.25em] text-[#EAE4D9]/80">
                  {t.menu.menuOfDay.priceCoffee}
                </span>
              </div>
              <p className="mt-10 border-t border-[#F5F2EB]/20 pt-6 font-body text-xs uppercase tracking-[0.25em] text-[#EAE4D9]/75">
                {t.menu.menuOfDay.half}
              </p>
            </div>
          </div>

          {/* Specialties */}
          <div className="lg:col-span-7">
            <div className="flex items-center gap-3">
              <UtensilsCrossed
                className="h-4 w-4 text-[#5C3A21]"
                strokeWidth={1.5}
              />
              <span
                data-testid="menu-highlights-label"
                className="font-body text-xs uppercase tracking-[0.35em] text-[#5C3A21]"
              >
                {t.menu.highlights}
              </span>
            </div>
            <ul className="mt-8 divide-y divide-[#1A1A1A]/15 border-y border-[#1A1A1A]/15">
              {t.menu.dishes.map((dish, i) => (
                <li
                  key={i}
                  data-testid={`menu-dish-${i}`}
                  className="group flex items-center justify-between py-5 transition-colors"
                >
                  <span className="font-serif-display text-2xl text-[#1A1A1A] sm:text-3xl">
                    {dish}
                  </span>
                  <span className="font-body text-[10px] uppercase tracking-[0.3em] text-[#5C3A21] opacity-0 group-hover:opacity-100 transition-opacity">
                    Casa
                  </span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
